import { SerializedStyles, css } from '@emotion/react';

export const STATIC_STYLES: SerializedStyles = css`
    position: static;
    -webkit-transition: none;
    transition: none;

    &[data-sticky] {
        left: auto;
        right: auto;
        bottom: auto;
        top: auto;
        z-index: calc(var(--hc-z-index-sticky) + var(--sticky-z-index-adjustment, 0));
    }

    &[data-sticky='fixed'] {
        position: fixed;
    }

    &[data-sticky='bound'] {
        position: absolute;
    }
`;

export function useDynamicStyles(zIndexAdjustment: number): React.CSSProperties {
    return {
        '--sticky-z-index-adjustment': zIndexAdjustment,
    } as React.CSSProperties;
}
